<template>
    <div>
        <img v-if="engagement.user != null" :src="profileImg" class="direct-chat-img timeline-img" alt="">

        <div class="timeline-item">
            <span class="time">
                <i class="fa fa-clock-o"></i> {{ engagement.created | humanFormat }}
            </span>
            <h3 class="timeline-header">
                <a v-if="engagement.user != null" :href="'/users/'+engagement.user_id">{{ engagement.user.first_name }}</a>
                <template v-else>{{ engagement.payload.first_name }}</template>

                entered the <a
                :href="'/e/' + engagement.participant.occasion.slug + '-' + engagement.payload.occasion.id">{{
                    engagement.payload.occasion.name
                }}</a> on {{ engagement.participant.original_completed | dateTimeFormat }}
            </h3>
            <div class="timeline-body">

                <div class="row">

                    <div class="col-md-6">
                        <div v-if="engagement.participant.registration_category.human_status == 'human_status_open'">
                            <ul>
                                <li v-if="engagement.participant.occasion.show_participant_complete_count">Remaining places:
                                    {{ engagement.participant.registration_category.capacity_remain }}
                                </li>
                                <li>Status: <span class="text-bold">{{
                                        engagement.participant.registration_category.human_status | registrationCategoryStatus
                                    }}</span></li>
                                <li v-if="engagement.participant.registration_category.closing_date">Entries close
                                    <span class="text-bold">{{ engagement.participant.registration_category.closing_date | humanFormat }}</span>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <p> The event is currently closed for entries </p>
                        </div>
                    </div>
                    <div class="col-md-6 text-right">
                        <img :src="engagement.participant.occasion.img_path" class="feedImg hidden-xs" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    dateTimeFormat,
    humanFormat
} from '../../../../../../../src/Assets/components/Utility/filters/dates'
import {registrationCategoryStatus} from '../../../../../../../src/Assets/components/RegistrationCategories/filters/registration_category_status'

export default {
    name: "ClubParticipant",
    props: {
        engagement: {
            type: Object,
            default: () => ({}),
            required: true
        }
    },
    filters: {
        dateTimeFormat,
        humanFormat,
        registrationCategoryStatus,
    },
    computed: {
        profileImg() {

            if (this.engagement.user.profile_image_path.substring(1, 6) != "files") {
                return '/img/' + this.engagement.user.profile_image_path;
            }

            return this.engagement.user.profile_image_path;
        },
        fullName() {
            return data => `${data.payload.first_name} ${data.payload.last_name}`
        }
    }
}
</script>

<style scoped>
ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// plugins/Crm/UsersFeed/Assets/components/Engagements/Entities/ClubParticipant.vue